module.exports = __webpack_public_path__ + "static/media/1017029.14b25ef8.jpg";